<app-ikony-svg></app-ikony-svg>
<router-outlet></router-outlet>
